var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.834 10H3.83398M21.834 12.5V8.8C21.834 7.11984 21.834 6.27976 21.507 5.63803C21.2194 5.07354 20.7605 4.6146 20.196 4.32698C19.5542 4 18.7142 4 17.034 4H8.63398C6.95382 4 6.11374 4 5.47201 4.32698C4.90752 4.6146 4.44858 5.07354 4.16096 5.63803C3.83398 6.27976 3.83398 7.11984 3.83398 8.8V17.2C3.83398 18.8802 3.83398 19.7202 4.16096 20.362C4.44858 20.9265 4.90752 21.3854 5.47201 21.673C6.11374 22 6.95382 22 8.63398 22H12.834M16.834 2V6M8.83398 2V6M15.334 19L17.334 21L21.834 16.5",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarCheck);
export default __webpack_public_path__ + "static/media/ic-calendar-check.b16d75dd582729c7813a9812865f9a4f.svg";
export { ForwardRef as ReactComponent };